import React, { PureComponent, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './UsersManagementTable.css';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { reactTableSortOnClick, isObjectsEqual } from 'common/utils/helpers';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import classnames from 'classnames';
import {
  updateUsersManagementSelectedUsersList,
  updateUsersManagementSelectedUserId,
  removeUsersManagementSelectedUserData,
  clearUsersManagementSelectedUsersList,
  setUsersManagementSelectMode
} from 'redux/actions';

const UserCheckBox = ({ targetUserId, selectMode }) => {
  const dispatch = useDispatch();
  const selectedUsersDictionary = useSelector((store) => store.ui.usersManagementPage.selectedUsersDictionary);

  return (
    <div className="UserManagementTable_Checkbox_Div">
      <Checkbox
        isChecked={selectedUsersDictionary[targetUserId]}
        onChange={(event) => {
          let selected = !(selectedUsersDictionary[targetUserId] === true);
          dispatch(updateUsersManagementSelectedUsersList({ [targetUserId]: selected }));

          if (!selected) dispatch(removeUsersManagementSelectedUserData(targetUserId));
          if (selectMode.allSelect === true) dispatch(setUsersManagementSelectMode({ allSelect: false }));

          event.stopPropagation(); //stop default row click stuff from happening
        }}
      />
    </div>
  );
};

const UserHeaderCheckBox = ({ users, selectMode }) => {
  const dispatch = useDispatch();

  return (
    <div className="UserManagementTable_Checkbox_Div">
      <Checkbox
        isChecked={selectMode.allSelect === true}
        onChange={(event) => {
          if (selectMode.allSelect !== true && users) {
            let selectedUsersIDs = {};
            // let selectedUsersData = {};
            users.forEach((user) => {
              selectedUsersIDs[user.user_id] = true;
              // selectedUsersData[user.user_id] = user;
            });
            dispatch(updateUsersManagementSelectedUsersList(selectedUsersIDs));
            //   dispatch(updateUsersManagementSelectedUsersData(selectedUsersData));
            dispatch(setUsersManagementSelectMode({ allSelect: true }));
          } else {
            dispatch(updateUsersManagementSelectedUserId(null));
            dispatch(clearUsersManagementSelectedUsersList());
            dispatch(setUsersManagementSelectMode({ allSelect: false }));
          }
        }}
      />
    </div>
  );
};

const columns = (parent) => [
  {
    Header: (col) => {
      return (
        <div className="UsersManagementTable_Header_OuterDiv">
          {parent.props.hasAuthAssignPermission && (
            <UserHeaderCheckBox users={parent.props.filteredUsers?.local} selectMode={parent.props.selectMode} />
          )}
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Names'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'user_name')}
          />
          <div className="UsersManagementPageHeader_ResizerSliderIcon">
            <div className="UsersManagementPageHeader_ResizerSliderIcon_Bar"></div>
          </div>
        </div>
      );
    },
    id: 'user_name',
    minWidth: 100,
    accessor: (user) => {
      return { userName: user.name, userId: user.user_id };
    },
    Cell: (row) => {
      return (
        <div className="UsersManagement_IdColumn UsersManagementTable_cellWrapper">
          {parent.props.hasAuthAssignPermission && (
            <UserCheckBox targetUserId={row.value.userId} selectMode={parent.props.selectMode} />
          )}
          <a
            to={''}
            data-tip={row.value.userName}
            onClick={async () => {
              await parent.props.dispatch(updateUsersManagementSelectedUserId(row.value.userId));
              await parent.props.parent.setState({ userDetailModalOpen: true, selectedUserId: row.value.userId });
            }}
          >
            {row.value.userName}
          </a>
        </div>
      );
    },
    sortMethod: (a, b) => {
      return a.userName.toLowerCase() > b.userName.toLowerCase() ? 1 : -1;
    }
  },
  {
    Header: (col) => {
      return (
        <div className="UsersManagementTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Emails'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'user_email')}
          />
          <div className="UsersManagementPageHeader_ResizerSliderIcon">
            <div className="UsersManagementPageHeader_ResizerSliderIcon_Bar"></div>
          </div>
        </div>
      );
    },
    id: 'user_email',
    minWidth: 100,
    accessor: (user) => {
      return user.email;
    },
    Cell: (row) => {
      return (
        <div className="UsersManagementTable_cellWrapper" data-tip={row.value}>
          {row.value}
        </div>
      );
    },
    sortMethod: (a, b) => {
      return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
    }
  },
  {
    Header: (col) => {
      return (
        <div className="UsersManagementTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Roles'}
            reverse
            onClick={() => {
              reactTableSortOnClick(parent, 'user_roles');
            }}
          />
        </div>
      );
    },
    id: 'user_roles',
    resizable: false,
    minWidth: 170,
    accessor: (user) => {
      let userId = user.user_id;
      let roles = null;
      let roleUsers = parent.props?.roleUsers;
      let stringForSorting = '';

      if (userId && roleUsers) roles = roleUsers[userId];

      roles && roles.forEach((role) => (stringForSorting += role.role));

      return { roles, stringForSorting };
    },
    Cell: (row) => {
      let roles = row.value.roles;
      let chips =
        roles &&
        roles.map((role) => {
          return (
            <div className="UsersManagementPage_RoleChip" key={role.role} data-tip={role.description}>
              {role.role}
            </div>
          );
        });

      return (
        <div className={classnames({ UsersManagementTable_cellWrapper: true, UsersManagementPage_ChipsWrapper: true })}>
          {chips}
        </div>
      );
    },
    sortMethod: (a, b) => {
      return a.stringForSorting.toLowerCase() > b.stringForSorting.toLowerCase() ? 1 : -1;
    }
  },
  {
    Header: (col) => {
      return <div className="UsersManagementTable_Header_OuterDiv"></div>;
    },
    id: 'user_actions',
    minWidth: 10,
    resizable: false,
    filterable: false,
    sortable: false,
    accessor: (user) => {
      return user.user_id;
    },
    Cell: (row) => {
      let modalName = 'UsersManagementTable_MoreActionModal-' + row.value;
      let dotsButton = (
        <div className={'editDots'}>
          <SvgAF
            img={IconLoader.icon_three_more}
            hover={IconLoader.icon_three_more_hover}
            tooltip={'More actions'}
            onClick={() => parent.props.dispatch(updateUsersManagementSelectedUserId(row.value))}
          />
        </div>
      );

      return (
        <div className="UsersManagementTable_cellWrapper">
          {/* {
                        parent.props.hasAuthDeletePermission &&
                        <DropModal title={dotsButton} name={modalName}>
                            <div className="UserManagementTable_MoreActionItem" onClick={() => null}>Delete the user</div>
                            <div className="UserManagementTable_MoreActionItem" onClick={() => null}>Deactivate the user</div>
                        </DropModal>
                    } */}
        </div>
      );
    }
  }
];

class UsersManagementTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sorted: [{ id: 'user_name', asc: true }],
      renderKey: 0
    };

    this.columns = columns(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isObjectsEqual(prevProps.roleUsers, this.props.roleUsers)) {
      this.setState({ renderKey: Math.random() * 10 });
    }
  }

  render() {
    const {
      props: { usersStatus, roleUsersStatus, filteredUsers },
      state: { sorted, renderKey },
      columns
    } = this;

    let usersData = filteredUsers && filteredUsers.local ? filteredUsers.local : [];
    let usersFetching = usersStatus === Status.PENDING;
    let roleUsersFetching = roleUsersStatus === Status.PENDING;
    let usersError = usersStatus === Status.FAILURE;
    let roleUsersError = roleUsersStatus === Status.FAILURE;
    let pageSize = filteredUsers && filteredUsers.local ? filteredUsers.local.length : 0;
    let overlay = null;

    if (usersError || roleUsersError) {
      overlay = (
        <div className="Global_Table_ErrorOverlay">
          <div className="Global_Table_Error_Div">
            <div className="Global_Table_ErrorOverlay_Title">Error </div>
            <div className="Global_Table_ErrorOverlay_Message">
              An unknown error occured while getting the list of users. If this problem persists, please contact us at
              <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="UsersManagementPage_TableContainer" key={renderKey}>
        <ScrollReactTable
          pageSize={pageSize}
          showPagination={false}
          resizable={false}
          sortable={false}
          minRows={13}
          className={'-highlight UsersManagementPage_Table Global_Table'}
          defaultPageSize={50}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (handleOriginal) handleOriginal();
              }
            };
          }}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo) {
              return {
                className: 'rowStyle',
                style: {
                  // height: '40px',
                  transition: 'all .5s ease'
                }
              };
            } else {
              return {};
            }
          }}
          data={usersData}
          columns={columns}
          sorted={sorted}
          onSortedChange={(newSorted, column, shiftKey) => {
            this.setState({ sorted: newSorted, dummy: true });
          }}
          fetching={usersFetching || roleUsersFetching}
          overlay={overlay}
        />
      </div>
    );
  }
}

export default memo(UsersManagementTable);
